module.exports = __webpack_public_path__ + "assets/2bede1dc9d161959418f20f770d91550.mp3";